import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowLeft, ArrowRight } from "lucide-react";
import { legalDoc } from "../features/legal/content";
import { LegalLinks } from "../features/legal/LegalLinks";
import { NoPurchaseBadge } from "../features/legal/NoPurchaseBadge";
import { LangToggle, ThemeToggle } from "../components/controls/Toggles";
import { NeuButton, NeuCard } from "../components/neu/Neu";

export default function LegalPage({ kind = "terms" }) {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const doc = legalDoc(kind, i18n.language);
  const Back = i18n.language === "ar" ? ArrowRight : ArrowLeft;

  return (
    <div className="min-h-[100dvh] bg-background px-5 py-8 sm:px-8">
      <div className="mx-auto max-w-3xl">
        <div className="mb-6 flex items-center justify-between gap-3">
          <NeuButton className="flex items-center gap-2 px-4 py-2" data-testid="legal-back" onClick={() => navigate(-1)}>
            <Back className="h-4 w-4" /> {t("legal.back")}
          </NeuButton>
          <div className="flex gap-2">
            <LangToggle />
            <ThemeToggle />
          </div>
        </div>
        <NeuCard className="animate-rise-in p-7 sm:p-9" data-testid={`legal-${kind}`}>
          <h1 className="text-3xl font-black tracking-tight sm:text-4xl">{doc.title}</h1>
          <p className="mt-2 text-xs font-semibold text-muted-foreground">
            {t("legal.version")} {doc.version} · {t("legal.updated")} {doc.updated}
          </p>
          <p className="mt-5 text-sm leading-7 text-muted-foreground">{doc.intro}</p>
          {kind === "terms" || kind === "eula" ? <NoPurchaseBadge /> : null}
          <div className="mt-8 grid gap-7">
            {doc.sections.map((s) => (
              <section key={s.h}>
                <h2 className="text-base font-black md:text-lg">{s.h}</h2>
                {s.p.map((para) => (
                  <p key={para.slice(0, 24)} className="mt-2 text-sm leading-7 text-muted-foreground">
                    {para}
                  </p>
                ))}
              </section>
            ))}
          </div>
          <div className="mt-9">
            <LegalLinks withLogin />
          </div>
        </NeuCard>
      </div>
    </div>
  );
}
